import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, from, map, Observable, of, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MsalService } from '@azure/msal-angular';
import { IScdItem } from '../interfaces/IScdItem';

@Injectable({
  providedIn: 'root',
})
export class ScdService {
  private http = inject(HttpClient);
  private msalService = inject(MsalService);

  private getAccessToken(): Observable<string> {
    const request = {
      scopes: environment.apiConfig[1].scopes,
      account: this.msalService.instance.getActiveAccount(),
    };

    return from(this.msalService.instance.acquireTokenSilent(request)).pipe(
      map(result => result.accessToken),
      catchError(error => {
        console.log('Silent token acquisition failed, trying popup...', error);
        return from(this.msalService.instance.acquireTokenPopup(request)).pipe(
          map(result => result.accessToken),
          catchError(popupError => {
            console.error('Popup token acquisition failed', popupError);
            return of(null);
          }),
        );
      }),
    );
  }

  public searchUserInSCD(firstName: string, surName: string, eMail: string): Observable<{ records: IScdItem[] }> {
    return this.getAccessToken().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': 'Bearer ' + token,
          'x-api-key': environment.scdApiKey,
          'Content-Type': 'application/json',
        });
        return this.http.get(environment.apiConfig[1].uri + this.buildUrlParameters(firstName, surName, eMail), { headers }) as Observable<{
          records: IScdItem[];
        }>;
      }),
    );
  }

  public getUserFromSCDByGid(gid: string): Observable<{ records: IScdItem[] }> {
    return this.getAccessToken().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': 'Bearer ' + token,
          'x-api-key': environment.scdApiKey,
          'Content-Type': 'application/json',
        });
        return this.http.get(`${environment.apiConfig[1].uri}?gid=${gid}`, {
          headers,
        }) as Observable<{ records: IScdItem[] }>;
      }),
    );
  }

  private buildUrlParameters(firstName: string, surName: string, eMail: string): string {
    const params = [
      ['firstName', firstName],
      ['surName', surName],
      ['mail', eMail],
    ].flatMap(([key, value]): string[] | string => (value ? `${key}=${value.trim().toLowerCase()}` : []));
    return params.length ? `?${params.join('&')}` : '';
  }
}
